export const INIT_STORE = 'INIT_STORE';

export interface InitStoreAction {
  type: typeof INIT_STORE
  payload: {
  }
}